module.exports = __webpack_public_path__ + "europa-50-emerald_number.jpg?53bd3b943358a82679cb419b4cc0c35c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50-emerald_number.jpg
// module id = 358
// module chunks = 0